import { render, staticRenderFns } from "./KategoriTanimlama.vue?vue&type=template&id=759be52f&scoped=true&"
import script from "./KategoriTanimlama.vue?vue&type=script&lang=js&"
export * from "./KategoriTanimlama.vue?vue&type=script&lang=js&"
import style0 from "./KategoriTanimlama.vue?vue&type=style&index=0&id=759be52f&scoped=true&lang=css&"
import style1 from "./KategoriTanimlama.vue?vue&type=style&index=1&id=759be52f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759be52f",
  null
  
)

export default component.exports